// ============================================================================
// PERMISSION SERVICE — self-service surface only
// ============================================================================
// Admin-side methods (getRolePermissionTree, bulkAssign, getUserPermissionTree,
// getUserEffectivePermissions) were removed when admin functionality moved to
// Centrix. What remains here is the current user's own navigation catalog,
// consumed by login-interface to build the dynamic sidebar.

import { get } from '../client/axiosClient';
import { myPermissionsEndpoints } from '../endpoints/iam.endpoints';
import type { ApiResponse } from '../types';
import type { UserNavigationDto } from '../types/iam.types';

class PermissionService {
  /** Fetch the current user's navigation tree filtered by role permissions */
  async getMyNavigation(): Promise<UserNavigationDto> {
    const response = await get<ApiResponse<UserNavigationDto>>(
      myPermissionsEndpoints.navigation()
    );
    return response.data.data;
  }
}

export const permissionService = new PermissionService();
export default permissionService;
